import { WORKER_PLAN_ACTIONS_TYPE } from "../actions-type";

const initialState = {
  workersPlan: [],
  totalLength: 0,
  hasMore: true,
  totalPages: 1,
  lastPage: "",
  loading: false,
};

export const workersPlanPaginationReducer = (state = initialState, action) => {
  switch (action.type) {
    case WORKER_PLAN_ACTIONS_TYPE.GET_ALL_WORKERS_PLAN:
      return {
        ...state,
        workersPlan: action.payload,
        loading: false,
      };
    case WORKER_PLAN_ACTIONS_TYPE.WORKER_LOADING_PLAN:
      return {
        ...state,
        loading: action.payload,
      };
    // case WORKER_PLAN_ACTIONS_TYPE.GET_WORKER_PAGINATION:
    //   return {
    //     ...state,
    //     workers: [...state.workers, ...action.payload.workers],
    //     totalLength: action.payload.totalLength,
    //     hasMore: !(action.payload.workers.length < 20),
    //   };
    case WORKER_PLAN_ACTIONS_TYPE.CREATE_WORKER_PLAN:
      return {
        ...state,
        workersPlan: [action.payload, ...state.workersPlan],
        totalLength: state.totalLength + 1,
      };
    // case WORKER_PLAN_ACTIONS_TYPE.RESET_WORKER_PAGINATION:
    //   return {
    //     ...state,
    //     workers: [],
    //     totalLength: 0,
    //     hasMore: true,
    //   };
    case WORKER_PLAN_ACTIONS_TYPE.UPDATE_WORKER_PLAN:
      return {
        ...state,
        workersPlan: state.workersPlan.map((workPlan) =>
          workPlan._id === action.payload._id ? action.payload : workPlan
        ),
      };
    case WORKER_PLAN_ACTIONS_TYPE.DELETE_WORKER_PLAN:
      return {
        ...state,
        workersPlan: state.workersPlan.filter(
          (workPlan) => workPlan._id !== action.payload
        ),
        totalLength: state.totalLength - 1,
      };
    // case WORKER_PLAN_ACTIONS_TYPE.GET_WORKER_LAST_PAGE:
    //   return {
    //     // ...state,
    //     lastPage: action.payload,
    //   };
    default:
      return state;
  }
};
